import React, {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import Button from "@mui/material/Button";
import { toPng } from "html-to-image";
import imgUploadService from "../../services/uploadImg";
import PaymentService from "../../services/payment";
import Toast from "../../components/toast/Toast";
import Backdrop from "../../components/backdrop/Backdrop";
import { formatDate } from "../../utils/date";
const Certificate = forwardRef(({ data }, ref) => {
  if (data) {
    var {
      receipt_no,
      mentor_name,
      donation_by,
      address,
      pan_number,
      transaction_id,
      amount,
      payment_date,
      kid_id,
      email,
    } = data;
  }

  const elementRef = useRef(null);
  const [toastMsg, setToastMsg] = useState("");
  const [toastStatus, setToastStatus] = useState("");
  const [toastOpen, setToastOpen] = useState(false);
  const [backdrop, setBackdrop] = useState(false);
  const [certificateUrl, setCertificateUrl] = useState();

  useImperativeHandle(ref, () => ({
    htmlToImageConvert(onComplete) {
      setBackdrop(true);
      toPng(elementRef.current, { cacheBust: false })
        .then(async (dataUrl) => {
          setCertificateUrl(dataUrl);
          try {
            let folder = "certificates";
            const uploadResult = await imgUploadService.uploadImg({
              image: dataUrl,
              folder,
            });
            const secureUrl =
              typeof uploadResult.data === "string"
                ? uploadResult.data
                : uploadResult.data?.url;
            if (!secureUrl || typeof secureUrl !== "string") {
              setToastMsg("Certificate upload did not return a valid URL.");
              setToastStatus("error");
              setBackdrop(false);
              return;
            }
            try {
              let paymentObj = {
                certificate_url: secureUrl,
                mentor_name,
                mentor_id: data?.mentor_id ?? null,
                transaction_id,
                amount,
                status: donation_by,
                payment_date: formatDate(payment_date),
                kid_id,
                is_anonymous: false,
                email,
                receipt_no,
                address,
                pan_number,
              };
              const payment = await PaymentService.addPayments(paymentObj);
              if (payment) {
                setToastOpen(true);
                setToastMsg(
                  "Certificate created and payment added successfully",
                );
                setToastStatus("success");
                setBackdrop(false);
                if (typeof onComplete === "function") onComplete();
              }
            } catch (err) {
              setToastMsg("Something went wrong!");
              setToastStatus("error");
              setBackdrop(false);
            }
          } catch (err) {
            setToastMsg("Something went wrong!");
            setToastStatus("error");
            setBackdrop(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setBackdrop(false);
        });
    },
  }));

  const onReceiptDownload = () => {
    const link = document.createElement("a");
    link.download = "my-image-name.png";
    link.href = certificateUrl;
    link.click();
  };

  return (
    <div>
      {/* Certificate Content */}
      {certificateUrl && (
        <Button
          color="primary"
          sx={{ mr: 1, mt: 1 }}
          variant="contained"
          className="receipt-download"
          onClick={onReceiptDownload}
        >
          Download
        </Button>
      )}

      <div
        ref={elementRef}
        style={{
          position: "relative",
          boxSizing: "border-box",
          width: "100%",
          backgroundColor: "#fff",
          padding: 20,
          fontFamily: "Arial, Helvetica, sans-serif",
          color: "#000",
        }}
      >
        <img
          src="/img/receiptHeader.png"
          alt="Header bg"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 0,
          }}
        />

        <img
          src="/img/header1.png"
          alt="Header"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 0,
          }}
        />

        {/* Main Content – same as frontend for identical receipt */}
        <div style={{ position: "relative", zIndex: 1, margin: 0, padding: 0 }}>
          <img
            src="/img/logo.png"
            alt="Logo"
            style={{
              display: "block",
              width: "100px",
              height: "auto",
              margin: "0 0 20px 0",
              padding: 0,
              verticalAlign: "top",
            }}
          />

          <div
            style={{
              position: "absolute",
              top: 0,
              left: "120px",
              fontFamily: "Georgia, Times New Roman, serif",
              fontSize: "12px",
              lineHeight: 1.5,
              color: "#000",
              zIndex: 0,
              margin: 0,
              padding: 0,
            }}
          >
            <div
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                lineHeight: 1.3,
                marginBottom: "6px",
              }}
            >
              SHAAGIRD FOUNDATION
            </div>
            <p style={{ margin: "0 0 4px 0", fontSize: "12px" }}>
              H No. 399 Prop No. 87G/F, Main 25 Ft Road, Shiv Vihar,
              <br />
              Karawal Nagar, North East Delhi 11009
              <br />
              contact@shaagird.org
              <br />
              <b>PAN:</b>ABJCS7197K <b style={{ marginLeft: 10 }}>CIN:</b>{" "}
              U80901DL2022NPL406795
            </p>
          </div>

          <div
            style={{
              textAlign: "center",
              color: "#000",
              marginTop: "88px",
              marginBottom: 0,
            }}
          >
            <h1
              style={{
                fontFamily: "Arial, Helvetica, sans-serif",
                fontSize: "30px",
                fontWeight: 700,
                margin: "0 0 10px 0",
                paddingBottom: "8px",
                letterSpacing: "0.02em",
              }}
            >
              DONATION RECEIPT
            </h1>
          </div>

          <div
            style={{
              position: "relative",
              textAlign: "center",
              marginTop: "18px",
              marginBottom: 0,
            }}
          >
            <img
              style={{ position: "absolute", width: 30, left: -5, top: -2 }}
              alt=""
              src="./img/quoteLeft.png"
            />
            <p
              style={{
                position: "relative",
                zIndex: 2,
                fontFamily: "Georgia, Times New Roman, serif",
                fontSize: "13px",
                fontStyle: "italic",
                lineHeight: 1.6,
                color: "#000",
                margin: "0 76px",
              }}
            >
              We at Shaagird Foundation express gratitude for the thoughtful and
              compassionate gesture on your part. This valuable contribution
              will greatly help us in restoring smiles.
            </p>
            <img
              style={{
                position: "absolute",
                width: 30,
                right: -10,
                bottom: 0,
              }}
              alt=""
              src="./img/quoteRight.png"
            />
          </div>

          <div
            style={{
              fontFamily: "Arial, Helvetica, sans-serif",
              fontSize: "14px",
              color: "#000",
              marginTop: "28px",
              lineHeight: 1.5,
              textAlign: "left",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                marginBottom: "10px",
                minHeight: "22px",
              }}
            >
              <span
                style={{
                  flex: "0 0 220px",
                  minWidth: "220px",
                  whiteSpace: "nowrap",
                  fontWeight: 400,
                }}
              >
                Receipt No:
              </span>
              <span
                style={{
                  flex: 1,
                  borderBottom: "2px dotted #000",
                  marginLeft: "8px",
                  fontWeight: "bold",
                  textAlign: "left",
                  minWidth: 0,
                }}
              >
                {receipt_no}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                marginBottom: "10px",
                minHeight: "22px",
              }}
            >
              <span
                style={{
                  flex: "0 0 220px",
                  minWidth: "220px",
                  whiteSpace: "nowrap",
                  fontWeight: 400,
                }}
              >
                Received with Thanks from:
              </span>
              <span
                style={{
                  flex: 1,
                  borderBottom: "2px dotted #000",
                  marginLeft: "8px",
                  fontWeight: "bold",
                  textAlign: "left",
                  minWidth: 0,
                }}
              >
                {mentor_name}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                marginBottom: "10px",
                minHeight: "22px",
              }}
            >
              <span
                style={{
                  flex: "0 0 220px",
                  minWidth: "220px",
                  whiteSpace: "nowrap",
                  fontWeight: 400,
                }}
              >
                Address:
              </span>
              <span
                style={{
                  flex: 1,
                  borderBottom: "2px dotted #000",
                  marginLeft: "8px",
                  fontWeight: "bold",
                  textAlign: "left",
                  minWidth: 0,
                }}
              >
                {address}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                marginBottom: "10px",
                minHeight: "22px",
              }}
            >
              <span
                style={{
                  flex: "0 0 220px",
                  minWidth: "220px",
                  whiteSpace: "nowrap",
                  fontWeight: 400,
                }}
              >
                The Sum of Rupees:
              </span>
              <span
                style={{
                  flex: 1,
                  borderBottom: "2px dotted #000",
                  marginLeft: "8px",
                  fontWeight: "bold",
                  textAlign: "left",
                  minWidth: 0,
                }}
              >
                ₹{amount}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                marginBottom: "10px",
                minHeight: "22px",
              }}
            >
              <span
                style={{
                  flex: "0 0 220px",
                  minWidth: "220px",
                  whiteSpace: "nowrap",
                  fontWeight: 400,
                }}
              >
                For/As Donations/Grant:
              </span>
              <span
                style={{
                  flex: 1,
                  borderBottom: "2px dotted #000",
                  marginLeft: "8px",
                  fontWeight: "bold",
                  textAlign: "left",
                  minWidth: 0,
                }}
              >
                Donation
              </span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                marginBottom: "10px",
                minHeight: "22px",
              }}
            >
              <span
                style={{
                  flex: "0 0 220px",
                  minWidth: "220px",
                  whiteSpace: "nowrap",
                  fontWeight: 400,
                }}
              >
                Through:
              </span>
              <span
                style={{
                  flex: 1,
                  borderBottom: "2px dotted #000",
                  marginLeft: "8px",
                  fontWeight: "bold",
                  textAlign: "left",
                  minWidth: 0,
                }}
              >
                {donation_by}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                marginBottom: "10px",
                minHeight: "22px",
              }}
            >
              <span
                style={{
                  flex: "0 0 220px",
                  minWidth: "220px",
                  whiteSpace: "nowrap",
                  fontWeight: 400,
                }}
              >
                Transaction:
              </span>
              <span
                style={{
                  flex: 1,
                  borderBottom: "2px dotted #000",
                  marginLeft: "8px",
                  fontWeight: "bold",
                  textAlign: "left",
                  marginRight: "12px",
                }}
              >
                {transaction_id}
              </span>
              <span
                style={{
                  flex: "0 0 60px",
                  minWidth: "60px",
                  whiteSpace: "nowrap",
                  fontWeight: 400,
                }}
              >
                Date:
              </span>
              <span
                style={{
                  flex: 1,
                  borderBottom: "2px dotted #000",
                  marginLeft: "8px",
                  fontWeight: "bold",
                  textAlign: "left",
                  minWidth: 0,
                }}
              >
                {formatDate(payment_date)}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                marginBottom: "10px",
                minHeight: "22px",
              }}
            >
              <span
                style={{
                  flex: "0 0 220px",
                  minWidth: "220px",
                  whiteSpace: "nowrap",
                  fontWeight: 400,
                }}
              >
                PAN Number:
              </span>
              <span
                style={{
                  flex: 1,
                  borderBottom: "2px dotted #000",
                  marginLeft: "8px",
                  fontWeight: "bold",
                  textAlign: "left",
                  minWidth: 0,
                }}
              >
                {pan_number}
              </span>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              marginTop: "56px",
              fontFamily: "Georgia, Times New Roman, serif",
              fontSize: "12px",
              color: "#000",
              fontWeight: "bold",
              alignItems: "flex-end",
            }}
          >
            <div style={{ flex: 1, textAlign: "left" }}>
              <p
                style={{
                  margin: 0,
                  fontSize: "12px",
                  lineHeight: 1.5,
                  fontWeight: 400,
                  textAlign: "left",
                }}
              >
                <b>Note:</b> Subject to realisation of cheque
                <br />
                Provisional Approval U/S 80G of Income Tax Act 1961 Under
                <br />
                Unique Registration Number <b>ABJCS7197KE20231</b>
              </p>
            </div>
            <div style={{ position: "relative", right: 52, flexShrink: 0 }}>
              <img
                src="/img/stamp.png"
                alt="Stamp"
                style={{
                  display: "block",
                  width: "100px",
                  marginBottom: "10px",
                }}
              />
              <p
                style={{
                  margin: 0,
                  fontFamily: "Georgia, Times New Roman, serif",
                  fontSize: "12px",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  position: "absolute",
                  bottom: 14,
                  left: -15,
                  fontWeight: 400,
                }}
              >
                Authorized Signature
                <br />
                <span>Shaagird Foundation</span>
              </p>
            </div>
          </div>
        </div>
        <img
          src="/img/receiptFooter.png"
          alt="Receipt Footer"
          style={{ position: "absolute", bottom: 0, left: 0, width: "100%" }}
        />

        {/* Optional Receipt Header/Footer if used */}
      </div>

      {toastOpen && (
        <Toast
          toastOpen={toastOpen}
          toastClose={() => setToastOpen(false)}
          toastMsg={toastMsg}
          toastStatus={toastStatus}
        />
      )}
      {backdrop && <Backdrop />}
    </div>
  );
});

export default Certificate;
